import { render } from "./LeadsPage.vue?vue&type=template&id=add055f6"
import script from "./LeadsPage.vue?vue&type=script&lang=js"
export * from "./LeadsPage.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./LeadsPage.vue?vue&type=style&index=0&id=add055f6&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__